import { ContextNavigate } from '../shared/components/context-navigate/context-navigate';

import { TransactionsComponent } from './containers/transactions';
import { TransactionsViewType } from './transactions.interface';

export default [
    {
        path: 'deposits',
        element: <TransactionsComponent view={TransactionsViewType.DEPOSITS} />,
    },
    {
        path: 'withdrawals',
        element: <TransactionsComponent view={TransactionsViewType.WITHDRAWALS} />,
    },
    {
        path: 'game-play',
        element: <TransactionsComponent view={TransactionsViewType.GAMEPLAY} />,
    },
    {
        path: 'sports-bets',
        element: <TransactionsComponent view={TransactionsViewType.SPORTS} />,
    },
    {
        path: '*',
        index: true,
        element: <ContextNavigate to={'/account/transactions/deposits'} replace />,
    },
];
